import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CalendarClock, ChevronRight } from 'lucide-react';
import { plazosAPI } from '../lib/api';
import { TIPOS, plazoState, pronto, windowText } from '../lib/plazos';

// Inicio → «Tu ciudad», first under its heading: at most three periods closing soon (lib/plazos.js pronto): the widely paid taxes (IBI, vehículos,
// basuras, agua, vados, IAE) within 15 days, job and grant calls within 10. Nothing renders when none does, or when the
// list cannot be loaded: it is a reminder, not a section of its own. The full list is Boletines → Plazos. Names stop at
// two lines here: a job call's full name ran to five in Modo Sénior on a phone; the tab shows it whole.

const TONE = { red: 'text-red-700', amber: 'text-amber-800', teal: 'text-torre-teal', grey: 'text-slate-500' };

export default function PlazosPronto() {
  const [data, setData] = useState(null);
  useEffect(() => {
    let alive = true;
    plazosAPI.list().then((res) => { if (alive) setData(res.data); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  if (!data) return null;
  const items = pronto(data.plazos || [], data.hoy);
  if (items.length === 0) return null;
  return (
    <div className="mb-3 pb-3 border-b border-slate-100" data-testid="plazos-pronto">
      <div className="flex items-center gap-1.5 mb-1.5">
        <CalendarClock size={14} className="text-torre-teal" aria-hidden="true" />
        <h3 className="text-xs font-extrabold text-slate-900 flex-1">Plazos que cierran pronto</h3>
        <Link to="/boletines?filtro=plazos" className="text-[11px] text-torre-teal font-bold hover:underline flex items-center gap-0.5">
          Ver todos <ChevronRight size={12} aria-hidden="true" />
        </Link>
      </div>
      <ul className="flex flex-col divide-y divide-slate-100">
        {items.map((p) => {
          const st = plazoState(p, data.hoy);
          return (
            <li key={p.id}>
              <Link to="/boletines?filtro=plazos" className="flex items-center gap-2 py-1.5 hover:bg-slate-50 rounded-lg">
                <span className="flex-1 min-w-0">
                  <span className="text-sm font-bold text-torre-slate leading-snug line-clamp-2" title={p.nombre}>{p.nombre}{p.periodo ? ` · ${p.periodo}` : ''}</span>
                  <span className="block text-[11px] text-slate-500">{TIPOS[p.tipo || 'tasa']} · {windowText(p)}</span>
                </span>
                <span className={`shrink-0 text-[11px] font-bold tabular-nums ${TONE[st.tone]}`}>{st.text}</span>
              </Link>
            </li>
          );
        })}
      </ul>
      <p className="text-[11px] text-slate-400 mt-1">Fechas leídas del BOC: vale el anuncio oficial.</p>
    </div>
  );
}
